<script setup lang="ts">
  import type { PageTitleStoryblok } from '@/storyblok/component-types-sb'

  defineProps<{
    blok: PageTitleStoryblok
  }>()

  const { isDesktop } = useBTBreakpoints()

  async function beforePrintCallback() {
    const closedAccordions = document.querySelectorAll('[aria-expanded="false"][id^="radix-vue-accordion-trigger"]')
    if (!closedAccordions.length) return true

    return new Promise((resolve) => {
      closedAccordions.forEach((accordion, index) => {
        const element = accordion as HTMLElement

        if (element) {
          element.click()
        }

        if (index === closedAccordions.length - 1) {
          // Accordion animation
          setTimeout(() => resolve(true), 1000)
        }
      })
    })
  }

  onMounted(() => {
    addEventListener('beforeprint', async () => await beforePrintCallback())
  })

  onUnmounted(() => {
    removeEventListener('beforeprint', async () => await beforePrintCallback())
  })

  async function print() {
    await beforePrintCallback()
    window.print()
  }
</script>
<template>
  <div
    class="flex w-full items-start justify-between"
    :class="{ 'md:gap-10': blok.hasPrintButton }"
  >
    <h1 class="m-0 break-words">{{ blok.title }}</h1>
    <UiButton
      v-if="blok.hasPrintButton && isDesktop"
      id="print-button"
      :title="$t('print')"
      icon="common/print-outline-rounded"
      variant="outline"
      size="lg"
      class="flex w-fit border-bt-blue-ui"
      @click="print()"
    />
  </div>
</template>
